import { GroupName } from '@/services/models/Product/GroupName';
import { msg } from '@/services/isomorphic/I18NService';
import { isNullish } from '@/utils/null-utils';
import { Nullable } from '@/type-utils';
import LoggerService from '@/services/isomorphic/LoggerService';
import { product_group_men } from "@/lang/__generated__/ahnu/product_group_men";
import { product_group_women } from "@/lang/__generated__/ahnu/product_group_women";
import { product_group_kids } from "@/lang/__generated__/ahnu/product_group_kids";
import { product_group_toddlers } from "@/lang/__generated__/ahnu/product_group_toddlers";
import { product_group_youth } from "@/lang/__generated__/ahnu/product_group_youth";
import { product_group_unisex } from "@/lang/__generated__/ahnu/product_group_unisex";
import { product_group_allgender } from "@/lang/__generated__/ahnu/product_group_allgender";
import { product_group_bigkids } from "@/lang/__generated__/ahnu/product_group_bigkids";
import { product_group_boys } from "@/lang/__generated__/ahnu/product_group_boys";
import { product_group_girls } from "@/lang/__generated__/ahnu/product_group_girls";

/**
 * Given a group identifier, returns the display name for that group.
 *
 * @param group - The group identifier.
 * @returns The display name for the group.
 */
export function getGroupDisplayName(group: Nullable<string>): Nullable<string> {
  if (isNullish(group)) return null;

  switch (group) {
    case GroupName.Men:
      return msg(product_group_men);
    case GroupName.Women:
      return msg(product_group_women);
    case GroupName.Kids:
      return msg(product_group_kids);
    case GroupName.Toddlers:
      return msg(product_group_toddlers);
    case GroupName.Youth:
      return msg(product_group_youth);
    case GroupName.Unisex:
      return msg(product_group_unisex);
    case GroupName.AllGender:
      return msg(product_group_allgender);
    case GroupName.BigKids:
      return msg(product_group_bigkids);
    case GroupName.Boys:
      return msg(product_group_boys);
    case GroupName.Girls:
      return msg(product_group_girls);
    default:
      LoggerService.warn(`Unknown group: ${group}`);
      return null;
  }
}
